var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PastTimeline',{attrs:{"timelineContent":_vm.pageData.past.timeline}},[_c('PastContent',[_c('RenderRichText',{attrs:{"content":_vm.pageData.past.overviewHTML}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }